import { CommonModule } from '@angular/common'
import { MatIconModule } from '@angular/material/icon'
import { NameEditorComponent } from './name-editor.component'
import { NgModule } from '@angular/core'
import { ScopeUiInputComponent } from '../ui-components/scope-ui-input/scope-ui-input.component'

@NgModule({
  declarations: [NameEditorComponent],
  exports: [NameEditorComponent],
  imports: [CommonModule, MatIconModule, ScopeUiInputComponent],
})
export class NameEditorModule {}
